import { ActionEnum } from '../../../actions/types/orderActions.types';
import OrderMassAction from './OrderMassAction';

class CancelOrders extends OrderMassAction {
  mustShowAction(): boolean {
    return this.allOrdersHaveAction([ActionEnum.MOVE_TO_CANCELED]);
  }
}

export default CancelOrders;
